import { render, staticRenderFns } from "./公司简介.vue?vue&type=template&id=dbc74dda&scoped=true&"
import script from "./公司简介.vue?vue&type=script&lang=js&"
export * from "./公司简介.vue?vue&type=script&lang=js&"
import style0 from "./公司简介.vue?vue&type=style&index=0&id=dbc74dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc74dda",
  null
  
)

export default component.exports